export const IconSlovakia = () => {
	return (
		<svg
			width="20px"
			height="14px"
			viewBox="0 0 20 14"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g id="Booking" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="Artboard" transform="translate(-55.9936, -110)" fillRule="nonzero">
					<g id="SK" transform="translate(55.9936, 110)">
						<polygon id="Path" fill="#FFFFFF" points="0 0 20 0 20 14 0 14"></polygon>
						<polygon
							id="Path"
							fill="#0052B4"
							points="0 4.56530976 20 4.56530976 20 9.4346728 0 9.4346728"
						></polygon>
						<polygon
							id="Path"
							fill="#D80027"
							points="0 9.43471374 20 9.43471374 20 14 0 14"
						></polygon>
						<path
							d="M5.05734893,3.95653397 L5.05734893,7.44851272 C5.05734893,9.43491842 7.52869396,10.0435223 7.52869396,10.0435223 C7.52869396,10.0435223 10,9.43483655 10,7.44851272 L10,3.95653397 L5.05734893,3.95653397 Z"
							id="Path"
							fill="#FFFFFF"
						></path>
						<path
							d="M5.70803119,4.05888356 L5.70803119,7.41981619 C5.70803119,7.64427135 5.75547758,7.85624087 5.84955166,8.05494694 L9.20775828,8.05494694 C9.30183236,7.8562818 9.34927875,7.64431229 9.34927875,7.41981619 L9.34927875,4.05888356 L5.70803119,4.05888356 Z"
							id="Path"
							fill="#D80027"
						></path>
						<polygon
							id="Path"
							fill="#FFFFFF"
							points="8.6445614 6.40229702 7.80764133 6.40229702 7.80764133 5.81645389 8.36561404 5.81645389 8.36561404 5.23061076 7.80764133 5.23061076 7.80764133 4.64472669 7.2497076 4.64472669 7.2497076 5.23061076 6.69181287 5.23061076 6.69181287 5.81645389 7.2497076 5.81645389 7.2497076 6.40229702 6.41274854 6.40229702 6.41274854 6.98814015 7.2497076 6.98814015 7.2497076 7.57398328 7.80764133 7.57398328 7.80764133 6.98814015 8.6445614 6.98814015"
						></polygon>
						<path
							d="M6.61064327,8.87273662 C6.97017544,9.10992306 7.33953216,9.24775646 7.52869396,9.30899756 C7.71781676,9.24771552 8.08721248,9.109964 8.44674464,8.87273662 C8.80931774,8.63350336 9.06354776,8.35980151 9.20783626,8.054906 C9.04323587,7.93238287 8.84639376,7.86667969 8.64463938,7.86692531 C8.56822612,7.86692531 8.4939961,7.87646353 8.42269006,7.89386157 C8.27146199,7.53308765 7.92822612,7.28108218 7.52877193,7.28108218 C7.12927875,7.28108218 6.78608187,7.53308765 6.6348538,7.89386157 C6.56210526,7.87601323 6.48764133,7.86696625 6.41290448,7.86692531 C6.2111501,7.86667969 6.01430799,7.93238287 5.8497076,8.054906 C5.99387914,8.35980151 6.24807018,8.63350336 6.61064327,8.87273662 Z"
							id="Path"
							fill="#0052B4"
						></path>
					</g>
				</g>
			</g>
		</svg>
	);
};
